export default "__VITE_ASSET__Lufnov7Q__"